import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=3c754f3b&scoped=true"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c754f3b",
  null
  
)

export default component.exports